import {QueryCommand} from "xmgoing-server";

export function useImgSelHook(props){

    const visible=ref(false);
    const imgRecordList=ref([]);

    const showImgSel=function (){
        if(props.disabled){
            return ;
        }
        visible.value=true;
    }

    const getImgList=()=>{
        const queryCommand = new QueryCommand({
            url: "/api/pe-portal/imgInfo/queryImgsByPage"
        });
        //执行查询操作
        queryCommand.executeQuery({
            params: {typeId:''}, successFun: (datas) => {
                if(datas&&datas.records){
                    imgRecordList.value=datas.records;
                }
            }
        });
    }

    return {
        imgRecordList,
        getImgList,
        visible,
        showImgSel
    }
}
